import { ApolloLink } from '@apollo/client';
import type { Resolvers, ResolverContext } from 'owa-graph-schema';
import { mailboxServerLink } from '../links/mailboxServerLink';
import { pstServerLink, isPstFileOperation } from '../links/pstServerLink';
import { unifiedInboxServerLink, isUnifiedInboxOperation } from '../links/unifiedInboxServerLink';
import { type DataSource } from 'owa-analytics-types';
import { messageFileServerLink, isMessageFileOperation } from '../links/messageFileServerLink';

export type ResolversProfile = {
    resolvers: Resolvers<ResolverContext>;
    dataSource?: DataSource;
    isOfflineEnabled: boolean;
};

export type ResolverImports = {
    offline?: Resolvers<ResolverContext>;
    pst?: Resolvers<ResolverContext>;
    unifiedInbox?: Resolvers<ResolverContext>;
    messageFile?: Resolvers<ResolverContext>;
    web: Resolvers<ResolverContext>;
};

export function createGraphServerLink(
    context: Record<string, any>,
    getResolvers: () => Promise<ResolverImports>,
    remoteLink: ApolloLink
): ApolloLink {
    return ApolloLink.split(
        isPstFileOperation,
        pstServerLink(context, getResolvers),
        ApolloLink.split(
            isUnifiedInboxOperation,
            unifiedInboxServerLink(context, getResolvers),
            ApolloLink.split(
                isMessageFileOperation,
                messageFileServerLink(context, getResolvers),
                mailboxServerLink(context, getResolvers, remoteLink)
            )
        )
    );
}
